import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import dashboardReducer from "./dashboard/dashboard.reducer";
import generalParamReducer from "./general_param/general_param.reducer";
import sidebarReducer from "./sidebar/sidebar.reducer";
import userReducer from "./user/user.reducer";



export const persistConfig = {
  key: "reporting_finance",
  storage,
  whitelist: ["sidebar","generalParam","user"],
  blacklist: [],
};

const topReducer = combineReducers({
  sidebar: sidebarReducer,
  dashboard: dashboardReducer,
  generalParam : generalParamReducer,
  user : userReducer
});

const rootReducer = (state: any, action: any) => {
  // when RESET action is dispatched it will reset redux state
  // if (action.type === authTypes.LOGOUT) {
  //   state = undefined;
  // }
  return topReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
